import React from 'react';
import styled from 'styled-components';

export const BadgeDescription = ({ description }: { description: string }) => <Description>{description}</Description>;

const Description = styled.span`
  display: block;
  font-size: 12px;
  font-weight: 400;
`;
